export default __webpack_public_path__ + "static/media/cordacertificate.66e7cc4a.jpeg";